import {
  Typography,
  Box,
  CircularProgress,
  Button,
  IconButton,
  Tooltip,
} from "@material-ui/core"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { openSnackBar } from "../../../../actions/snack-bar"
import { updateUserApprentice } from "../../../../actions/billing"
import useStyles from "./styles"
import React, { Fragment, useState } from "react"
import AutocompleteBilling from "../../Common/AutocompleteBilling/index"

import LocalLibraryIcon from "@material-ui/icons/LocalLibrary"
import useBillingDisabled from "../../../../hooks/useBillingDisabled"

const ApprenticeAutocomplete = ({ position }) => {
  const dispatch = useDispatch()
  const classesList = useSelector(state => state.billing.classesList)
  const [classValue, setClassValue] = useState(position.apprentice || null)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(Boolean(classValue))
  const classes = useStyles()
  const isDisabled = useBillingDisabled()

  const openClassAutocomplete = () => {
    setOpen(oldState => !oldState)
  }

  const saveApprentice = classObj => {
    let data = { apprentice: classObj.id }
    let shootRoleId = position.shoot_role
    setLoading(true)
    dispatch(updateUserApprentice(data, shootRoleId))
      .then(() => {
        dispatch(openSnackBar({ message: "Apprentice updated" }))
        setClassValue(classObj.id)
        setLoading(false)
        //close autocomplete if we save without apprentice
        if (classObj.id === null) {
          setOpen(false)
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error updating apprentice" }))
        setClassValue(classObj.id)
        setLoading(false)
      })
  }

  return (
    <Box marginLeft="10px">
      <Box display="flex" alignItems="center">
        {!open && (
          <Tooltip title="Open Apprentice" aria-label="open apprentice">
            <IconButton onClick={openClassAutocomplete}>
              <LocalLibraryIcon />
            </IconButton>
          </Tooltip>
        )}
        {open &&
          classesList.length > 0 && (
            <Box
              minWidth="300px"
              marginLeft="10px"
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
            >
              <Typography className={classes.label}>Apprentice of:</Typography>
              <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {loading ? (
                  <CircularProgress size="24px" />
                ) : (
                  <Fragment>
                    <AutocompleteBilling
                      disabled={isDisabled}
                      placeholder="Search Class"
                      getOptionLabel={option => option.name}
                      value={classesList.filter(
                        classObject => classObject.id === classValue
                      )}
                      className={classes.autocomplete}
                      labelKey="name"
                      blurInputOnSelect
                      backspaceRemovesValue
                      showValue
                      options={classesList}
                      caps
                      onChange={classObj => {
                        saveApprentice(classObj)
                      }}
                    />
                    <Tooltip
                      title="Delete apprentice"
                      aria-label="delete apprentice"
                    >
                      <Button
                        color="primary"
                        size="small"
                        onClick={() => saveApprentice({ id: null })}
                      >
                        Clear
                      </Button>
                    </Tooltip>
                  </Fragment>
                )}
              </Box>
            </Box>
          )}
      </Box>
    </Box>
  )
}

ApprenticeAutocomplete.propTypes = {
  position: PropTypes.object,
}

export default ApprenticeAutocomplete
